import { xyz_n_1of6_lists, xyz_n_4of6 } from './SL00000Sprint00'
import { orderedListSlide } from './SLSprint00'

import { submissionPercentage, tPrework, retrospectiveIntroduction } from './SLSprint00'
import { checklistAnnouncementsPreworkAndAgenda, completeDeck, tLab } from './SL00000Sprint00'

import { tPreworkWithLogo } from './SLSprint00'
import { basicSlideWithLogo } from './SLSprint00'
import { agendaSlide } from './SLSprint00'
import { makeSlideDeck } from './SL00000Sprint00'
import { insertInto } from './SLSprintPlanning'
import { sprintPlanningSlideDeck } from './SLSprintPlanning'

import { breakoutStandard } from './SLSprint00'

import { list44000Sprint06 } from '../ActivityLists/AL44000Sprint06'
import { list44000Sprint07 } from '../ActivityLists/AL44000Sprint07'

import { xyz_n_1of6 } from './SL00000Sprint00'

import { tDiscussionBreakout } from './SLSprint00'
import { bulletListSlide } from './SLSprint00'

import { ics_7_7of6_PAaA, breakoutSocialMedia, isItPossibleTo, confirmFinalExamAndPresentationTimes /*, workingWithIndia */ } from './SL20000Sprint07'

// import { tExamExpectations, tExam } from './SLSprint00'
import { basicSlide } from './SLSprint00'

// import { tNoClassToday } from './SL00000Sprint00'
import { reviewDemoSchedule } from './SLSprint00'
import { sprintDemosIntro, sprintDemos, demoAssignment } from './SLSprint00'

import { sprint7PlanningExpectations } from './SL20000Sprint07'

import { tMidtermExamExpectations, tExam } from './SLSprint00'

// Todo: Update naming to reflect that fact that there are nine class sessions in sprint 7. Note that that will cause issues 
// with the “http://localhost:3000/?cpsc=sp24-cpsc-44500-001#/deck/7-4” URL routing method. 

// Todo: theSocialDilemma, 
// import { theSocialDilemma } from './SL20000Sprint05'

// Software Engineering (SE) sprint 7 global values.
const sprint = 7
const activityListPrevious = () => { return list44000Sprint06(sprint-1) }
const activityList = () => { return list44000Sprint07(sprint) }

// Session 1 of 6: Monday
export const se_7_1of6 = () => { 
	const slideDeck = xyz_n_1of6(sprint, se_7_1of6_PAaA.prework, activityListPrevious, se_7_1of6_PAaA.agenda, 
		se_7_2of6_PAaA.prework, activityList, sprint7PlanningExpectations)
	insertInto(slideDeck, sprintPlanningSlideDeck(sprint), 8)
	return slideDeck
}

// Session 1 of 6: Monday
export const se_7_1of6_PAaA = xyz_n_1of6_lists(sprint)
export const se_7_2of6 = () => {
	const prework = () => { return tPreworkWithLogo('Prework For Today', se_7_2of6_PAaA.prework, sprint-1, activityList) }
	const announcements =  () => { return basicSlideWithLogo( 'Announcements', se_7_2of6_PAaA.announcements) }
	const agenda = () => { return agendaSlide(se_7_2of6_PAaA.agenda) }
	const preworkNext = () => { return tPrework('Prework For Next Class', se_7_2of6_PAaA.prework, sprint, activityList) }
	const reviewDemoSchedule = () => {
		return bulletListSlide('Review Friday’s Demo Schedule', 
			'Let’s review Friday’s demo schedule while recalling that demos are an important part of scrum and that they:', [
			'Occur at the beginning of each new sprint ',
			'Are an opportunity to show what was completed in the previous sprint',
			'Are an **easy** and hopefully rewarding experience to show off your work',
			'Provide a chance to see how others solved a problem and to see some of the challenges they faces' ]
		)
	}
	const discussionBreakout = () => { return tDiscussionBreakout(sprint) } 

	const slideDeck = makeSlideDeck([ prework, announcements, agenda, discussionBreakout, reviewDemoSchedule, preworkNext ])
	const slideDeckWithSprintPlanning = insertInto(slideDeck, sprintPlanningSlideDeck(sprint), 4)
	return slideDeckWithSprintPlanning
}

// Session 2 of 6: Wednesday
export const se_7_2of6_PAaA = {
	'prework':[
		'Complete through activity 4 prior to next class', '',
		`Be prepared Discussion Board ${sprint}`,
		'Be prepared Lab' ],
	'announcements':[ 
		'Review Final Exam date/time',
		'Review Class Project presentation data/time' ],
	'agenda':[
		`Sprint ${sprint} Commitments & Immutable Sprint ${sprint} Backlog`,
		`Discussion Board ${sprint} as a scrum team`,
		'Lab' ]
}
export const se_7_4of6X = () => { 
	const prework = () => { return tPreworkWithLogo('Prework For Today', se_7_2of6_PAaA.prework, sprint-1, activityListPrevious) }
	const announcements =  () => { return basicSlideWithLogo( 'Announcements', se_7_2of6_PAaA.announcements) }
	const agenda = () => { return agendaSlide(se_7_2of6_PAaA.agenda) }
	const preworkNext = () => { return tPrework('Prework For Next Class', se_7_2of6_PAaA.prework, sprint, activityList) }

	const discussionBreakout = () => { return tDiscussionBreakout(sprint) } 

	const slideDeck = makeSlideDeck([ prework, announcements, agenda, discussionBreakout, preworkNext, reviewDemoSchedule, tLab ])
	return slideDeck
}

// Session 3 of 6: Friday
const se_7_3of6_PAaA = {
	'prework':[
		'Complete through activity 4 prior to next class', '',
		`Be prepared sprint ${sprint-1} Demos and Retrospectives` ],
	'announcements':[
		'Lab 7 - Planning was due Wednesday',
		'No class Wednesday or Friday next week' ],
	'agenda':[
		'Review Final Exam date/time',
		'Review Class Project presentation data/time',
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		'Prework for Next Class' ]
}
export const se_7_3of6 = () => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:19, submitted:18 },
			{ name: 'Quiz', due:19, submitted:18 },
			{ name: 'Lab', due:19, submitted:17 },
			{ name: 'Reflection', due:19, submitted:18}])
	}
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
		'Feedback from Assignments & Reflections', [
		`Not so great from a submission percentage... two missing labs feels particularly difficult`,
		'Running behind on getting Lab 6 - Execution graded and posted',
		'Thank you for your Reflection comments',
		'Nice job working with your teams!... this is hard!' ])
	}
	/* Consider putting Best-of-the-Best Scrum Team Demos in a breakout session 
	const bestOfTheBestScrumTeamDemos = () => {
		return orderedListSlide('Best-of-the-Best Scrum Team Demos', 
			'Can’t wait to see!', [ ])
	}
*/

	const reviewFinalExamAndClassProjectPresentationTimes = () => {
		return orderedListSlide('Review Final Exam and Class Project Presentation Times',
			'Review Final Exam and Class Project Presentation Times:', [
			'Review Final Exam Time',
			'Review Class Project Presentation Times' ])
	}

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(se_7_3of6_PAaA, sprint, activityList)
	const retrospectiveInto = () => { return retrospectiveIntroduction(sprint)}
	const preworkNext = () => { return tPrework('Prework For Next Class', se_7_4of6_PAaA.prework, sprint, activityList) }
	return completeDeck(slideDeck, [ reviewFinalExamAndClassProjectPresentationTimes, sprintDemosIntro,  sprintDemos, demoAssignment, retrospectiveInto, 
		metricsSubmissionPercentage, retrospective, preworkNext])
}

// Sprint 7 session 4 of 6: Monday
const se_7_4of6_PAaA = {
	'prework':[
		'Complete through activity 5 prior to next class', '',
		'Be prepared for Project Management, Scrum, Pairs, and Version Control Systems Breakout',
		'Be prepared for Lab' ],
	'announcements':[
		'Monday is our Final Exam (in-person attendance required) **', '',
		'Final Exam: Verify your calendar is marked',
		'Class Project Presentation: Verify your calendar is marked' ],
	'agenda':[
		'Sprint Progress Polling',
		'Project Management, Scrum, Pairs, and Version Control Systems Breakout',
		'Lab' ]
}
export const se_7_4of6 = () => { 
	const breakout = () => { 
		return breakoutStandard( 
			'Breakout: Project Management, Scrum, Pairs, and Version Control Systems', 
			'In this breakout session we will explore key concepts and practices related to Project Management, Scrum, Pairs, and Version Control Systems:', [
				'Project Management: Planning, tracking progress, and delivering value',
				'Scrum: Roles, events, and artifacts in Agile development',
				'Pair Programming: Benefits, challenges, and best practices',
				'Version Control Systems: Git basics, branching, merging, and resolving conflicts',
				'Git Pull Requests: Managing contributions and code reviews',
				'Collaboration: Using tools like GitHub to manage team contributions',
				'Continuous Integration: Automating builds and tests to ensure code quality'
			]
		)
	}
	return xyz_n_4of6(sprint, se_7_4of6_PAaA, se_7_5of6_PAaA.prework, activityList, breakout)
}

// Sprint 7 session 5 of 6: Wednesday
const se_7_5of6_PAaA = {
	'prework':[
		'Complete through activity 5 prior to next class', '',
		'Be prepared for Project Management, Scrum, Pairs, and Version Control Systems Breakout',
		'Be prepared for Lab' ],
	'announcements':[
		'Review Final Exam date/time',
		'Review Class Project presentation data/time' ],
	'agenda':[
		'Sprint Progress Polling',
		'Project Management, Scrum, Pairs, and Version Control Systems Breakout',
		'Lab' ]
}
export const se_7_5of6 = () => { 
	const breakout = () => { 
		return breakoutStandard( 
			'Breakout: Project Management, Scrum, Pairs, and Version Control Systems', 
			'In this breakout session we will explore key concepts and practices related to Project Management, Scrum, Pairs, and Version Control Systems:', [
				'Project Management: Planning, tracking progress, and delivering value',
				'Scrum: Roles, events, and artifacts in Agile development',
				'Pair Programming: Benefits, challenges, and best practices',
				'Version Control Systems: Git basics, branching, merging, and resolving conflicts',
				'Collaboration: Using tools like GitHub to manage team contributions',
				'Continuous Integration: Automating builds and tests to ensure code quality'
			]
		)
	}
	return xyz_n_4of6(sprint, se_7_5of6_PAaA, se_7_6of6_PAaA.prework, activityList, breakout)
}

 // Sprint 7 session 6 of 6: Friday
const se_7_6of6_PAaA = {
	'prework':[
		'Be prepared Software Business Models, YouTube, and the competition for your eyes discussion' ],
	'announcements':[
		'Review Final Exam date/time',
		'Review Class Project presentation data/time' ],
	'agenda':[
		'Optional Lab',
		'Breakout ons Social Media and Technology Business Models',
		'Social Media, YouTube, and Technology Business Models' ]
}
export const se_7_6of6 = () => { 

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(se_7_6of6_PAaA, sprint, activityList)
	const preworkNext = () => { return tPrework('Prework For Next Class', se_7_7of6_PAaA.prework, sprint, activityList) }
	return completeDeck(slideDeck, [ tLab, preworkNext, breakoutSocialMedia, isItPossibleTo ]) 
}

// Session 7 of 6: Monday
const se_7_7of6_PAaA = ics_7_7of6_PAaA

export const se_7_7of6 = () => {
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(se_7_7of6_PAaA, sprint, activityList)
	const preworkNext = () => { return tPrework('Prework For Next Class', se_7_8of6_PAaA.prework, sprint, activityList) }
	return completeDeck(slideDeck, [ confirmFinalExamAndPresentationTimes, preworkNext, tMidtermExamExpectations, tExam ]) 
}

// Sprint 7 session 8 of 6: Wednesday
const se_7_8of6_PAaA = {
	'prework': [ 
		'Be prepared for Final Exam'],
	'announcements': [
		`All sprint ${sprint} assignments due Sunday`,
		`All sprint ${sprint+1} assignment two hours before your Class Project Presentation` ],
	'agenda': [ 
		'Review Class Project presentation Date, Time, and Expectations',
		'Final Exam' ]
}
const confirmPresentationTimes = () => {
	return orderedListSlide('Confirm Class Project Presentation Times',
		'Confirm Class Project Presentation Times', [ ] )
}
const finalProjectPresentation = () => {
	return orderedListSlide('Class Project Presentation Schedule and Expectations ', 
		'Review Class Project Presentation requirements', [ ])
}
export const se_7_8of6 = () => {
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(se_7_8of6_PAaA, sprint, activityList)
	const preworkNext = () => { return tPrework('Prework For Next Class', se_7_9of6_PAaA.prework, sprint, activityList) }
	return completeDeck(slideDeck, [ confirmPresentationTimes, preworkNext, tMidtermExamExpectations, tExam ])
}

const se_7_9of6_PAaA = { 
	'prework':[
		'Be prepared for Sprint 8 Planning',
		`Be prepared for Lab` ],
	'announcements':[
		`All sprint ${sprint} assignments due Sunday`,
		`All sprint ${sprint+1} assignment due two hours before your Class Project Presentation` ],
	'agenda':[
		'Review Class Project presentation Date, Time, and Expectations',
		`Final review of sprint ${sprint} and sprint ${sprint+1} assignments` ]
}
export const se_7_9of6 = () =>  { 
	const sprint8Planning = () => {
	return orderedListSlide('Sprint Planning', `Sprint ${sprint+1} Expectations:`, [
		'Sprint 8 is all about presenting your Class Project',
		'Submit Lab 8 at least two hours prior to your schedule Class Project Presentation time',
		'No assignments will be accepted after Wednesday' ])
}
	const finalReviewActivityListAndAssignments = () => { return basicSlide(
		`Final sprint ${sprint} and ${sprint+1} activity list and assignment Q&A`, [`Any sprint ${sprint} activity list or assignment questions?`]) }
	const nextSteps = () => { return tPrework('Next Steps', [ 
		`All sprint ${sprint} assignments due Sunday`,
		'Remaining Class Project presentations next week Monday by 8:30 am CT'], 
		sprint, activityList) }

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(se_7_9of6_PAaA, sprint, activityList)
	return completeDeck(slideDeck, [ sprint8Planning, finalProjectPresentation, finalReviewActivityListAndAssignments, nextSteps ]) 
}